import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";

const InputCheckboxWrapper = (props) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  return (
    <div className={styles.container}>
      <input
        id={props.name}
        name={props.name}
        type="checkbox"
        checked={checked}
        onChange={props.onChange}
      />
      <label htmlFor={props.name} className={styles.Label}>
        <span className={styles.labelText}>{props.label}</span>
      </label>
      <div className={styles.children}>{props.children}</div>
    </div>
  );
};

export default InputCheckboxWrapper;
